const APP_CONFIGURATION = {
  development: {
    apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:3001',
    apiClientId: process.env.REACT_APP_API_CLIENT_ID,
    apiClientSecret: process.env.REACT_APP_API_CLIENT_SECRET,
    accountHost: `localhost:${process.env.REACT_APP_PORT || 5000}`,
  },
  test: {
    apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:3001',
    apiClientId: process.env.REACT_APP_API_CLIENT_ID,
    apiClientSecret: process.env.REACT_APP_API_CLIENT_SECRET,
    accountHost: `localhost:${process.env.REACT_APP_PORT || 5000}`,
  },
  staging: {
    apiUrl: 'https://api-eu-staging.mimi.io/app/v2',
    apiClientId: 'api-client-mimi-account-portal',
    apiClientSecret: '87bb1cb3eee8a473c1c0903e27e8d6af9e97bcc2febb03dabaeb8234bc19aea4',
    accountHost: 'account-staging.mimi.io',
  },
  staging_cn: {
    apiUrl: 'https://api-staging.mimihearing.cn/app/v2',
    apiClientId: 'api-client-mimi-account-portal',
    apiClientSecret: '87bb1cb3eee8a473c1c0903e27e8d6af9e97bcc2febb03dabaeb8234bc19aea4',
    accountHost: 'account-staging.mimihearing.cn',
  },
  production: {
    apiUrl: 'https://api-eu.mimi.io/app/v2',
    apiClientId: 'api-client-mimi-account-portal',
    apiClientSecret: 'a53a1795c71acdc6fcf659ee73a3d8abf3779441c27a5972ae0aa07e3fe7f245',
    accountHost: 'account.mimi.io',
  },

  production_cn: {
    apiUrl: 'https://api.mimihearing.cn/app/v2',
    apiClientId: 'api-client-mimi-account-portal',
    apiClientSecret: 'a53a1795c71acdc6fcf659ee73a3d8abf3779441c27a5972ae0aa07e3fe7f245',
    accountHost: 'account.mimihearing.cn',
  },
};

module.exports = (() => {
  const host = window.location.host;
  if (!/^release/.test(host) && !/^hotfix/.test(host)) {
    for (const key in APP_CONFIGURATION) {
      if (host.includes(APP_CONFIGURATION[key].accountHost)) {
        return APP_CONFIGURATION[key];
      }
    }
  }
  return APP_CONFIGURATION[process.env.NODE_ENV] || APP_CONFIGURATION.production;
})();



// WEBPACK FOOTER //
// ./src/helper/app-config.js